import React, { FC } from "react";

const Dashboard: FC = () => {
  return <section id="dashboard-view" className="panel-view"></section>;
};

export default Dashboard;
